<script setup lang="ts">

import { computed } from "vue";
import { usePresentation } from '@presentation/Types/Presentation';
const presentation = usePresentation();

const isVideo = computed( () => [ '.mov', '.mp4', '.webm', '.avi' ].some( e => presentation.mediaSrc.endsWith( e ) ) );

</script>

<template>

    <!-- bg-gradient-to-b from-[#13142d] via-50% via-[#101126] to-[#363483] -->
    <div 
        class="absolute w-full h-full  flex items-center justify-center top-0 left-0"
        :style="{ 
            background: `black linear-gradient( to bottom, rgb( from ${presentation.theme.bgColorFrom} r g b / 30%), rgb( from black r g b / 100%), rgb( from ${presentation.theme.bgColorFrom} r g b / 20%) )`
        }">

        <video 
            v-if="isVideo"
            ref="video"
            width="100%" 
            autoplay 
            controls 
            class="w-[84%] rounded-2xl shadow-xl shadow-white/20 ring-[3px] ring-white"
            onloadstart="this.volume=0.3">
            <source :src="presentation.mediaSrc" type="video/mp4" />
        </video> 

        <div v-else 
             class="max-w-[84%] h-full rounded-2xl shadow-xl shadow-white/20 ring-[3px] ring-white overflow-hidden">
            <img :src="presentation.mediaSrc" class="w-full object-contain h-full" />
        </div>

        <button 
            title="Restart the presentation"
            @click="() => presentation.showMedia = false"
            class="absolute z-10 top-6 right-6 hover:brightness-110 hover:bg-white/[4%] rounded-full w-11 h-11 flex items-center justify-center hover:shadow tracking-wider">
            <Icon name="cross" />
        </button>

    </div>

</template>